import { Box, Typography } from '@mui/material';
import { Wifi as WifiIcon } from '@mui/icons-material';

const CreditCardPreview = ({ creditCardInfo }) => {
  const { number, fullName, month, year } = creditCardInfo;

  return (
    <Box
      sx={{
        width: 320,
        height: 200,
        borderRadius: '16px',
        background: 'linear-gradient(135deg, #0d1a3f 0%, #091427 100%)',
        color: '#fff',
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
        fontFamily: 'monospace',
        position: 'relative',
      }}
    >
      {/* Chip & Contactless */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box
          sx={{
            width: 40,
            height: 30,
            borderRadius: 4,
            background: 'linear-gradient(#bbb, #eee)',
          }}
        />
        <WifiIcon sx={{ fontSize: 24 }} />
      </Box>

      {/* Card Number */}
      <Typography variant="h6" sx={{ letterSpacing: 2 }}>
        {number || '**** **** **** ****'}
      </Typography>

      {/* Name & Expiry */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant="caption" sx={{ color: '#aaa' }}>
            NOME DO TITULAR
          </Typography>
          <Typography variant="body2">{fullName || 'SEU NOME AQUI'}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" sx={{ color: '#aaa' }}>
            VÁLIDO ATÉ
          </Typography>
          <Typography variant="body2">
            {month || 'MM'}/{year?.slice(-2) || 'AA'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CreditCardPreview;
